// extracted by mini-css-extract-plugin
export default {"modal_buttons":"modal_buttons___ZQE7j"};